import React from "react";
import { motion } from "framer-motion";
import { SectionLabel } from "../components/SectionLabel";
import { ClosingCTA } from "../components/ClosingCTA";
import { IntelligenceSearch } from "../components/intelligence/IntelligenceSearch";
import { JurisdictionIndex } from "../components/intelligence/JurisdictionIndex";
import { LibraryIndex } from "../components/intelligence/LibraryIndex";
import { RecentUpdates } from "../components/intelligence/RecentUpdates";
import { useIntelligenceSearch } from "../hooks/useIntelligenceSearch";
import { ledgerEase } from "../utils/motion";
export function Intelligence() {
  const search = useIntelligenceSearch();
  const handleJurisdiction = (name: string) => {
    search.setQuery(name);
    document.getElementById("intel-search")?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  return <>
      <section aria-labelledby="intelligence-title" className="shell pb-24 pt-20 md:pb-32 md:pt-28" data-id="element-781" data-mp="1h4w1qfti673i">
        <div className="flex flex-wrap items-baseline justify-between gap-4" data-id="element-782" data-mp="1m3gvpxi5vuji">
          <SectionLabel data-id="element-783" data-mp="8kgy5ho4ysmi">Constant Intelligence</SectionLabel>
          <p className="text-[11px] uppercase tracking-[0.14em] text-charcoal/60" data-id="element-784" data-mp="3lvwddt8k0vy">Client preview · In development</p>
        </div>
        <motion.h1 id="intelligence-title" initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: ledgerEase
      }} className="mt-8 max-w-5xl font-display text-[clamp(2.75rem,5.6vw,5.25rem)] leading-[1.02] tracking-[-0.015em] text-navy" data-id="element-785" data-mp="3uz0914dwjpo8">
          Everything we know about running payroll, <em className="text-oxblood" data-id="element-786" data-mp="3c2qmdsoxpqsm">searchable</em>.
        </motion.h1>
        <p className="mt-8 max-w-2xl text-lg leading-relaxed text-charcoal/80" data-id="element-787" data-mp="380vlgpax1ffd">
          Jurisdiction guides, system guides, playbooks, and issue intelligence — the same knowledge our operators use
          on live engagements, organized to answer a question in seconds.
        </p>

        <IntelligenceSearch search={search} data-id="element-788" data-mp="2zrzoiavldjzh" />
      </section>

      <JurisdictionIndex onSelect={handleJurisdiction} data-id="element-789" data-mp="2zqetyl9a211m" />
      <LibraryIndex data-id="element-790" data-mp="34iprxikgjcrj" />
      <RecentUpdates data-id="element-791" data-mp="34j7wr3l6qzb2" />
      <ClosingCTA title={<>
            Built for the people who <em className="text-oxblood" data-id="element-793" data-mp="2qscnvraosi7h">run</em> payroll.
          </>} body="Constant Intelligence is available to clients, maintained by the operators who rely on it. Ask us about access." data-id="element-792" data-mp="34kj0x4ijm92p" />
    </>;
}